import { getBooking } from "../../../app/api/getBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { calculatePrice, isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum, TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookedOffer, IBookingResponse, IBookingTypeTrip, IReservation } from "../../../Orchestrator/Types/Index";
import { IBookItAgainShowModalActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookItAgainShowModalActionParams";
import { IAlreadyAddonsForPassenger, IAlreadyAddonsLegPassengerAddons } from "../../../Orchestrator/Types/Interface/IAddOns";
import { getAllOfferWithoutExchangeAction } from "../../LogicActions/CommonActions/GetAllOfferWithoutExchangeAction";
import { getAllTripWithoutExchangeAction } from "../../LogicActions/CommonActions/GetAllTripWithoutExchangeAction";


export class BookItAgainShowModalAction extends BaseAction<void, IBookItAgainShowModalActionParams> {

    override async run(): Promise<void | null> {
        try {
            const { trip } = this.params!
            updateRecoilState("markSelectedDateAsDisableAtom", {
                OUT_BOUND: [],
                IN_BOUND: []
            });
            updateRecoilState("selectedDatePriceAtom", []);
            updateRecoilState("selectedTripForBookItAgainAtom", trip);
            updateRecoilState("calendarStateAtom", {
                selectedDates: [null, null],
                isFilled: false,
            });

            if (trip.bookingType == "oneWayTrip") {
                updateRecoilState("isModalVisibleAtom", true);
            }
            if (trip.bookingType == "roundTrip") {
                updateRecoilState("isRoundTripModalVisibleAtom", true);
            }

            const bookingId = trip.bookingId
            if (bookingId) {
                const response: any = await getBooking(bookingId);
                if (response.status === "ok" && response.answer) {
                    const { booking }: IBookingResponse = response.answer;
                    updateRecoilState("selectedBookingForBookItAgainAtom", booking);

                    let allBookedOfferWithoutExchange: IBookedOffer[] = []
                    let allBookedTripWithoutExchange: IBookingTypeTrip[] = []

                    getAllOfferWithoutExchangeAction.setParams(booking.bookedOffers)
                    await getAllOfferWithoutExchangeAction.execute();
                    if (isActionRunSuccessfully(getAllOfferWithoutExchangeAction)) {
                        allBookedOfferWithoutExchange = getAllOfferWithoutExchangeAction?.result || []
                        if (allBookedOfferWithoutExchange.length > 0) {
                            getAllTripWithoutExchangeAction.setParams({ bookedOffers: allBookedOfferWithoutExchange, trips: booking.trips })
                            await getAllTripWithoutExchangeAction.execute()
                            if (isActionRunSuccessfully(getAllTripWithoutExchangeAction)) {
                                allBookedTripWithoutExchange = getAllTripWithoutExchangeAction?.result || []
                            }
                        }
                    }
                    if (allBookedOfferWithoutExchange.length > 0 && allBookedTripWithoutExchange.length > 0) {
                        const alreadyAddonsLegPassenger: IAlreadyAddonsLegPassengerAddons = {}
                        allBookedOfferWithoutExchange.forEach((bookedOffer: IBookedOffer) => {
                            let bookTrip = allBookedTripWithoutExchange.find(d => d.id === bookedOffer.tripCoverage.coveredTripId)
                            const allAncillaryForTrip: IReservation[] = bookedOffer.ancillaries.filter(d => d.tripCoverage.coveredTripId === bookTrip?.id && d.status !== "REFUNDED")
                            
                            for (const ancillaries of allAncillaryForTrip) {
                                const passengerIds = ancillaries.passengerIds || []
                                const products = ancillaries.products || []
                                const legIds = ancillaries.tripCoverage?.coveredLegIds || []
                                
                                for (const passengerId of passengerIds) {
                                    const passengerDetails = booking.passengers.find(d => d.id === passengerId)
                                    if (!passengerDetails) continue
                                    
                                    for (const product of products) {
                                        const productId = product.productId
                                        const productDetails = bookedOffer.products.find(d => d.id === productId)
                                        
                                        for (const legId of legIds) {
                                            const bookTripLeg = bookTrip?.legs.find(d => d.id === legId)
                                            if (!bookTripLeg) continue
                                            
                                            const passenger: IAlreadyAddonsForPassenger = {
                                                category: ancillaries.type,
                                                addonName: productDetails?.description || "",
                                                passengerId: passengerDetails?.id || "",
                                                passengerName: `${passengerDetails?.detail?.firstName || ""} ${passengerDetails?.detail?.lastName || ""}`,
                                                passengerRef: passengerDetails?.externalRef || "",
                                                type: productDetails?.code || "",
                                                price: calculatePrice(ancillaries?.price) || 0,
                                                stopCode: `${bookTripLeg?.timedLeg.start.stopPlaceRef.stopPlaceRef}-${bookTripLeg?.timedLeg.end.stopPlaceRef.stopPlaceRef}`
                                            }
                                            
                                            let direction = bookTrip?.direction || ""
                                            direction = direction === TripTypeEnum.IN_BOUND ? TrainTypeEnum.inbound : TrainTypeEnum.outbound
                                            
                                            if (!alreadyAddonsLegPassenger[direction]) {
                                                alreadyAddonsLegPassenger[direction] = []
                                            }
                                            alreadyAddonsLegPassenger[direction].push(passenger)
                                        }
                                    }
                                }
                            }
                        })
                        updateRecoilState("alreadyAddonsLegPassengerAtom", alreadyAddonsLegPassenger)
                    }
                }
            }

            try {
                const element = document.getElementById("details_arrow")
                if (element) {
                    element.style.display = "none"
                }
            } catch (error) {

            }
        } catch (error) {

        }
    }
}

export const bookItAgainShowModalAction = new BookItAgainShowModalAction(); 